import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getEntries, getSearch, getFilters, getSettings } from '../../common/services/selectors';
import TabItem from '../components/_TabItem';

function EventTabs({ search, filters, settings }) {
    let filterKeys = ['0/44/45/47/50','0/44/45/47/48','0/44/45/47/49'];

	const toggle = (e) => {
        e.currentTarget.classList.toggle('active');
        let list = document.getElementsByClassName('events-listing-filter__list');
        list[0].classList.toggle('collapsed');
    };
    
    return (
    <nav className="events-listing-filter"> 
        <a className="filter_list--dropdown" href="javascript: void(0)" onClick={toggle}>
            Filter
            <svg className="icon"><use xlinkHref="#icon-chevron-down"></use></svg>
        </a>
        <div className="row column">
            <ul className="events-listing-filter__list collapsed">
            <TabItem currentSearch={search} type='eventType' search='all' settings={settings}>All</TabItem>
                {filters.taxonomyFilters && 
                    filters.taxonomyFilters.eventType &&
                    filters.taxonomyFilters.eventType.children.map((t, index) => {
                        if(filterKeys.includes(t.key)){
                            return <TabItem currentSearch={search} type='eventType' key={index} index={index} search={t.key} settings={settings}>{t.name}</TabItem>

                        }
                    })
                }
            </ul>
        </div>
    </nav>
	);
}
EventTabs.propTypes = {
    entries: PropTypes.object,
    search: PropTypes.object, 
    filters: PropTypes.object, 
    settings: PropTypes.object
};

const mapStateToProps = state => ({ entries: getEntries(state), search: getSearch(state), filters: getFilters(state), settings: getSettings(state) });

export default connect(mapStateToProps)(EventTabs);